module.exports = __webpack_public_path__ + "img/logo.a03b61b4.png";